import angular from 'angular';

angular
  .module('cloudX')
  .controller('OkCancelDialogCtrl', [
    '$scope',
    'appMessages',
    'close',
    'title',
    'message',
    yesNoDialogCtrl,
  ]);

function yesNoDialogCtrl($scope, appMessages, close, title, message) {
  $scope.title = appMessages(title);
  $scope.message = appMessages(message);
  $scope.close = function(result) {
    close(result, 500);
  };
}
